import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import img from '../images/success-popup__icon.svg'
import {airtable_config_get_label, closePopup} from "../redux/actions";

export const SuccessPopup = () => {
    const dispatch = useDispatch()
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const successPopup = useSelector(state => state.app.successPopup)
    const message = configData !== null ? airtable_config_get_label(configData, 'success_message', locale) : null;
    const handlePopupCloseClick = () => {
        dispatch(closePopup());
    }
    useEffect(() => {
        const timer = setInterval(() => {
            if (successPopup) {
                dispatch(closePopup());
            }
        }, 6000);
        return () => clearInterval(timer);
    }, [successPopup]);
    if (!successPopup) {
        return null;
    }

    return (
        <div className="success-popup">
            <div className="success-popup__close" onClick={() => handlePopupCloseClick()}/>
            <div className="success-popup__icon"><img src={img} alt="" title=""/></div>
            <div className="success-popup__message">{message}</div>
        </div>
    )
}